import { render, staticRenderFns } from "./AccountHolderExternalBankAccounts.vue?vue&type=template&id=671f9602&scoped=true"
import script from "./AccountHolderExternalBankAccounts.vue?vue&type=script&lang=ts"
export * from "./AccountHolderExternalBankAccounts.vue?vue&type=script&lang=ts"
import style0 from "./AccountHolderExternalBankAccounts.vue?vue&type=style&index=0&id=671f9602&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671f9602",
  null
  
)

export default component.exports